import type { Category } from './types';

export const categories: Category[] = [
  {
    id: '1',
    name: '剧情解析',
    slug: 'plot-analysis',
    description: '深入剖析《色戒》的剧情脉络、人物关系与叙事技巧，解读李安导演的电影语言与隐藏细节。',
    icon: 'ri-movie-2-line',
    count: 8,
  },
  {
    id: '2',
    name: '版本对比',
    slug: 'version-comparison',
    description: '对比《色戒》删减版与无删减版的内容差异，了解被删减片段对影片艺术表达的完整性影响。',
    icon: 'ri-contrast-2-line',
    count: 5,
  },
  {
    id: '3',
    name: '创作背景',
    slug: 'creation-background',
    description: '探索李安导演的创作历程、原著张爱玲小说背景、演员访谈与幕后故事，全面了解影片诞生过程。',
    icon: 'ri-lightbulb-line',
    count: 6,
  },
  {
    id: '4',
    name: '资源指南',
    slug: 'resource-guide',
    description: '提供《色戒》无删减版高清正版资源的获取渠道、蓝光收藏版信息与在线观看平台推荐。',
    icon: 'ri-guide-line',
    count: 4,
  },
];